import barba from '@barba/core';
import gsap from 'gsap';

if(!$('body').hasClass('logged-in')){
    let oldColor;

    const fadeOut = (element) => {
        const color = $(element).find('main').css( "background-color" );
        $('.page-transition').css('background-color', color).css('top', '100%').css('opacity', 0);
        oldColor = color;
        return gsap.to('.page-transition', {
            duration: 0.6,
            y: '-100%',
            opacity: 1,
            display: "block",
        });

    }

    const fadeIn = (element) => {
        const color = $(element).find('main').css( "background-color" );
        $('.page-transition').css('background-color', oldColor).css('top', '0').css('opacity', 1);

        const timeline = gsap.timeline({
            paused: true,
        })

        timeline
            .to('.page-transition', {
                backgroundColor: color,
                duration: 0.5,
            })
            .to('.page-transition', {
                opacity: 0,
                duration: 1,
                display: "none",
            }, 0.5)

        return timeline.play();
    }

    barba.hooks.enter(() => {
        window.scrollTo(0, 0);
    });

    barba.init({
        prefetchIgnore: true,
        debug: true,
        transitions:[{
            name: 'default',
            async leave(data) {
                await fadeOut(data.current.container);
            },
            async after(data) {
                await fadeIn(data.next.container);
            },
        }],
    });
}
